export default __webpack_public_path__ + "static/media/chosen-second-card.1603fd3a.svg";